import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContainerEmptyTask = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

export const ContainerQuestions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const Header = styled(TextLayoutComponent.Bold)`
  font-size: 16px;
  margin-bottom: 10px;
`;
